{
  "605": {
    "port_name": "Nuuk (Gronnedal (Kangilinnguit))",
    "country": "Greenland"
  },
  "6500": {
    "port_name": "Detroit (Windsor)",
    "country": "Canada"
  },
  "7560": {
    "port_name": "New York (Port Jefferson)",
    "country": "United States"
  },
  "7650": {
    "port_name": "New York (Yonkers)",
    "country": "United States"
  },
  "8050": {
    "port_name": "Los Angeles (Wilmington)",
    "country": "United States"
  },
  "8180": {
    "port_name": "New York (Cape Charles)",
    "country": "United States"
  },
  "8225": {
    "port_name": "Baltimore (Annapolis)",
    "country": "United States"
  },
  "8750": {
    "port_name": "Colón (Panama City)",
    "country": "United States"
  },
  "9170": {
    "port_name": "Houston (Baytown)",
    "country": "United States"
  },
  "9360": {
    "port_name": "Tampico",
    "country": "Mexico"
  },
  "9510": {
    "port_name": "Progreso",
    "country": "Mexico"
  },
  "9810": {
    "port_name": "Puerto Limon",
    "country": "Costa Rica"
  },
  "9985": {
    "port_name": "Freeport",
    "country": "The Bahamas"
  },
  "9990": {
    "port_name": "Nassau",
    "country": "The Bahamas"
  },
  "10580": {
    "port_name": "Georgetown",
    "country": "Cayman Islands"
  },
  "10772": {
    "port_name": "Kingston (Port Esquivel)",
    "country": "Jamaica"
  },
  "10930": {
    "port_name": "Cap Haitien",
    "country": "Haiti"
  },
  "11048": {
    "port_name": "Santo Domingo (Punta Nizao Oil Terminal)",
    "country": "Dominican Republic"
  },
  "11370": {
    "port_name": "Philipsburg",
    "country": "Sint Maarten"
  },
  "11690": {
    "port_name": "Bridgetown",
    "country": "Barbados"
  },
  "11770": {
    "port_name": "Port of Spain (Point Fortin)",
    "country": "Trinidad and Tobago"
  },
  "11901": {
    "port_name": "Cartagena (Covenas Offshore Term.)",
    "country": "Colombia"
  },
  "11930": {
    "port_name": "Barranquilla",
    "country": "Colombia"
  },
  "11934": {
    "port_name": "Cartagena (Puerto Prodeco)",
    "country": "Colombia"
  },
  "12275": {
    "port_name": "Maracaibo (Puerto De Hierro)",
    "country": "Venezuela"
  },
  "12410": {
    "port_name": "Paramaribo",
    "country": "Suriname"
  },
  "12491": {
    "port_name": "Belém (Vila Do Conde)",
    "country": "Brazil"
  },
  "12775": {
    "port_name": "Salvador (Madre De Deus)",
    "country": "Brazil"
  },
  "12890": {
    "port_name": "Rio de Janeiro (Macae)",
    "country": "Brazil"
  },
  "13970": {
    "port_name": "Rio Grande",
    "country": "Argentina"
  },
  "14470": {
    "port_name": "Valparaíso (Puerto San Antonio)",
    "country": "Chile"
  },
  "14500": {
    "port_name": "Valparaíso (Bahia De Valparaiso)",
    "country": "Chile"
  },
  "14660": {
    "port_name": "Antofagasta",
    "country": "Chile"
  },
  "14800": {
    "port_name": "Arica (Rada De Arica)",
    "country": "Chile"
  },
  "14955": {
    "port_name": "Lima (La Pampilla Oil Terminal)",
    "country": "Peru"
  },
  "15170": {
    "port_name": "Paita",
    "country": "Peru"
  },
  "15250": {
    "port_name": "Puerto Bolivar",
    "country": "Ecuador"
  },
  "15370": {
    "port_name": "Buenaventura",
    "country": "Colombia"
  },
  "15423": {
    "port_name": "Colón (Vacamonte)",
    "country": "Panama"
  },
  "15770": {
    "port_name": "Manzanillo",
    "country": "Mexico"
  },
  "15990": {
    "port_name": "Ensenada",
    "country": "Mexico"
  },
  "16070": {
    "port_name": "Long Beach",
    "country": "United States"
  },
  "17700": {
    "port_name": "Seattle (Tacoma)",
    "country": "United States"
  },
  "20097": {
    "port_name": "Akutan Harbor",
    "country": "United States"
  },
  "20110": {
    "port_name": "Makushin",
    "country": "United States"
  },
  "20690": {
    "port_name": "Vadso",
    "country": "Norway"
  },
  "21315": {
    "port_name": "Tromsø (Olavsvern)",
    "country": "Norway"
  },
  "23040": {
    "port_name": "Trondheim (Rorvik)",
    "country": "Norway"
  },
  "23107": {
    "port_name": "Molde (Bud)",
    "country": "Norway"
  },
  "23118": {
    "port_name": "Bergen (Orstav)",
    "country": "Norway"
  },
  "23525": {
    "port_name": "Stavanger (Stusvik)",
    "country": "Norway"
  },
  "23700": {
    "port_name": "Larvik",
    "country": "Norway"
  },
  "23870": {
    "port_name": "Gothenburg (Stromstad)",
    "country": "Sweden"
  },
  "24000": {
    "port_name": "Gothenburg (Stenungsund)",
    "country": "Sweden"
  },
  "24030": {
    "port_name": "Gothenburg (Varberg)",
    "country": "Sweden"
  },
  "24040": {
    "port_name": "Gothenburg (Falkenberg)",
    "country": "Sweden"
  },
  "24180": {
    "port_name": "Malmö (Landskrona)",
    "country": "Sweden"
  },
  "24300": {
    "port_name": "Kristianstad (Ahus)",
    "country": "Sweden"
  },
  "24900": {
    "port_name": "Farosund",
    "country": "Sweden"
  },
  "25610": {
    "port_name": "Norrsundet",
    "country": "Sweden"
  },
  "26710": {
    "port_name": "Kopmanholmen",
    "country": "Sweden"
  },
  "27130": {
    "port_name": "Brannfors",
    "country": "Sweden"
  },
  "27650": {
    "port_name": "Vaasa",
    "country": "Finland"
  },
  "28190": {
    "port_name": "Helsinki",
    "country": "Finland"
  },
  "28230": {
    "port_name": "Kotka",
    "country": "Finland"
  },
  "28654": {
    "port_name": "Klaipėda (Butinge Oil Terminal)",
    "country": "Lithuania"
  },
  "28740": {
    "port_name": "Gdańsk (Gdynia)",
    "country": "Poland"
  },
  "28828": {
    "port_name": "Rostock (Wolgast)",
    "country": "Germany"
  },
  "29110": {
    "port_name": "Bornholm (Ronne)",
    "country": "Denmark"
  },
  "29490": {
    "port_name": "Copenhagen (Kalundborg)",
    "country": "Denmark"
  },
  "30230": {
    "port_name": "Aarhus (Horsens)",
    "country": "Denmark"
  },
  "30720": {
    "port_name": "Hamburg (Brunsbuttel Canal Terminals)",
    "country": "Germany"
  },
  "30725": {
    "port_name": "Hamburg (Itzehoe)",
    "country": "Germany"
  },
  "30800": {
    "port_name": "Hamburg (Cuxhaven)",
    "country": "Germany"
  },
  "31085": {
    "port_name": "Rotterdam (Europoort)",
    "country": "Netherlands"
  },
  "31150": {
    "port_name": "Rotterdam (Dordrecht)",
    "country": "Netherlands"
  },
  "31270": {
    "port_name": "Antwerp (Ghent)",
    "country": "Belgium"
  },
  "31320": {
    "port_name": "Antwerp (Nieuwpoort)",
    "country": "Belgium"
  },
  "31470": {
    "port_name": "London",
    "country": "United Kingdom"
  },
  "31550": {
    "port_name": "London (Ipswich)",
    "country": "United Kingdom"
  },
  "31680": {
    "port_name": "Hull (Bridlington)",
    "country": "United Kingdom"
  },
  "31930": {
    "port_name": "Edinburgh (Leith)",
    "country": "United Kingdom"
  },
  "32690": {
    "port_name": "Torshavn",
    "country": "Faroe Islands"
  },
  "33400": {
    "port_name": "Glasgow (Faslane)",
    "country": "United Kingdom"
  },
  "34360": {
    "port_name": "Cork",
    "country": "Ireland"
  },
  "34400": {
    "port_name": "Dublin (Waterford)",
    "country": "Ireland"
  },
  "34480": {
    "port_name": "Dublin",
    "country": "Ireland"
  },
  "35650": {
    "port_name": "Brighton (Newhaven Harbour)",
    "country": "United Kingdom"
  },
  "35700": {
    "port_name": "Dover (Folkestone Harbour)",
    "country": "United Kingdom"
  },
  "37040": {
    "port_name": "La Rochelle (Rochefort)",
    "country": "France"
  },
  "37290": {
    "port_name": "San Sebastián (Puerto De Pasajes)",
    "country": "Spain"
  },
  "37400": {
    "port_name": "Puerto De Bilbao",
    "country": "Spain"
  },
  "37470": {
    "port_name": "Santander",
    "country": "Spain"
  },
  "37770": {
    "port_name": "La Coruna",
    "country": "Spain"
  },
  "37900": {
    "port_name": "Vigo",
    "country": "Spain"
  },
  "37980": {
    "port_name": "Coimbra (Figueira Da Foz)",
    "country": "Portugal"
  },
  "37990": {
    "port_name": "Lisboa",
    "country": "Portugal"
  },
  "38005": {
    "port_name": "Sines",
    "country": "Portugal"
  },
  "38150": {
    "port_name": "Santa Cruz De La Palma",
    "country": "Spain"
  },
  "38170": {
    "port_name": "Las Palmas",
    "country": "Spain"
  },
  "38220": {
    "port_name": "Huelva",
    "country": "Spain"
  },
  "38270": {
    "port_name": "Sevilla",
    "country": "Spain"
  },
  "38395": {
    "port_name": "Almería (Puerto De Carboneras)",
    "country": "Spain"
  },
  "38440": {
    "port_name": "Alicante",
    "country": "Spain"
  },
  "38460": {
    "port_name": "Valencia (Puerto De Gandia)",
    "country": "Spain"
  },
  "38543": {
    "port_name": "Barcelona (Villanueva Y Geltru)",
    "country": "Spain"
  },
  "38780": {
    "port_name": "Marseille (Port-de-Bouc)",
    "country": "France"
  },
  "39140": {
    "port_name": "Sardinia (Maddalena)",
    "country": "Italy"
  },
  "39370": {
    "port_name": "Genoa (Imperia)",
    "country": "Italy"
  },
  "39500": {
    "port_name": "Genoa (Chiavari - Lavagna)",
    "country": "Italy"
  },
  "39550": {
    "port_name": "La Spezia (Marina Di Carrara)",
    "country": "Italy"
  },
  "39720": {
    "port_name": "Elba (Portoferraio)",
    "country": "Italy"
  },
  "39930": {
    "port_name": "Naples (Baia)",
    "country": "Italy"
  },
  "40040": {
    "port_name": "Naples (Salerno)",
    "country": "Italy"
  },
  "40080": {
    "port_name": "Messina (Reggio Di Calabria)",
    "country": "Italy"
  },
  "40330": {
    "port_name": "Valletta Harbors",
    "country": "Malta"
  },
  "40460": {
    "port_name": "Crotone (Corigliano Calabro)",
    "country": "Italy"
  },
  "40520": {
    "port_name": "Bari (Mola Di Bari)",
    "country": "Italy"
  },
  "40690": {
    "port_name": "Ancona (Pesaro)",
    "country": "Italy"
  },
  "40710": {
    "port_name": "Rimini (Cesenatico)",
    "country": "Italy"
  },
  "40745": {
    "port_name": "Venice (Porto Di Chioggia)",
    "country": "Italy"
  },
  "40790": {
    "port_name": "Trieste (Monfalcone)",
    "country": "Italy"
  },
  "40985": {
    "port_name": "Brsica",
    "country": "Croatia"
  },
  "43260": {
    "port_name": "Kalimnos",
    "country": "Greece"
  },
  "43500": {
    "port_name": "Burgas",
    "country": "Bulgaria"
  },
  "43560": {
    "port_name": "Constanta",
    "country": "Romania"
  },
  "44200": {
    "port_name": "Novorossiysk",
    "country": "Russia"
  },
  "44542": {
    "port_name": "Botas Natural Gas Terminal",
    "country": "Turkey"
  },
  "44620": {
    "port_name": "Istanbul (Izmit)",
    "country": "Turkey"
  },
  "44640": {
    "port_name": "Bursa (Mudanya)",
    "country": "Turkey"
  },
  "44650": {
    "port_name": "Bursa (Bandirma)",
    "country": "Turkey"
  },
  "44740": {
    "port_name": "Dikili",
    "country": "Turkey"
  },
  "44801": {
    "port_name": "Mersin (Toros Gubre)",
    "country": "Turkey"
  },
  "44805": {
    "port_name": "Marmaris",
    "country": "Turkey"
  },
  "44820": {
    "port_name": "Antalya",
    "country": "Turkey"
  },
  "44860": {
    "port_name": "Mersin",
    "country": "Turkey"
  },
  "44910": {
    "port_name": "Xeros",
    "country": "Cyprus"
  },
  "45030": {
    "port_name": "Bayrut",
    "country": "Lebanon"
  },
  "45080": {
    "port_name": "Haifa",
    "country": "Israel"
  },
  "45100": {
    "port_name": "Ashdod",
    "country": "Israel"
  },
  "45140": {
    "port_name": "Bur Sa'id",
    "country": "Egypt"
  },
  "45320": {
    "port_name": "Misratah",
    "country": "Libya"
  },
  "45490": {
    "port_name": "Annaba",
    "country": "Algeria"
  },
  "45515": {
    "port_name": "Arzew (Port Methanier)",
    "country": "Algeria"
  },
  "45550": {
    "port_name": "Bejaia",
    "country": "Algeria"
  },
  "45570": {
    "port_name": "Alger",
    "country": "Algeria"
  },
  "45650": {
    "port_name": "Oran (Mers El Kebir)",
    "country": "Algeria"
  },
  "45730": {
    "port_name": "Ceuta",
    "country": "Spain"
  },
  "45755": {
    "port_name": "Tangier (Tanger)",
    "country": "Morocco"
  },
  "45793": {
    "port_name": "Casablanca",
    "country": "Morocco"
  },
  "45802": {
    "port_name": "Agadir",
    "country": "Morocco"
  },
  "45812": {
    "port_name": "Nouadhibou",
    "country": "Mauritania"
  },
  "45821": {
    "port_name": "Rufisque",
    "country": "Senegal"
  },
  "45855": {
    "port_name": "Conakry",
    "country": "Guinea"
  },
  "45862": {
    "port_name": "Freetown",
    "country": "Sierra Leone"
  },
  "45880": {
    "port_name": "Mindelo (Porto Grande)",
    "country": "Cabo Verde"
  },
  "46090": {
    "port_name": "Lome",
    "country": "Togo"
  },
  "46560": {
    "port_name": "Luanda",
    "country": "Angola"
  },
  "46650": {
    "port_name": "Luderitz Bay",
    "country": "Namibia"
  },
  "46690": {
    "port_name": "Jamestown",
    "country": "Saint Helena, Ascension, and Tristan da Cunha"
  },
  "46770": {
    "port_name": "Cape Town",
    "country": "South Africa"
  },
  "46870": {
    "port_name": "Maputo",
    "country": "Mozambique"
  },
  "46910": {
    "port_name": "Quelimane",
    "country": "Mozambique"
  },
  "46935": {
    "port_name": "Nacala",
    "country": "Mozambique"
  },
  "48264": {
    "port_name": "Ras Al Khaimah (Mina Saqr)",
    "country": "United Arab Emirates"
  },
  "48276": {
    "port_name": "Dubai (Mina Jabal Ali)",
    "country": "United Arab Emirates"
  },
  "48600": {
    "port_name": "Karachi",
    "country": "Pakistan"
  },
  "49930": {
    "port_name": "Port Klang",
    "country": "Malaysia"
  },
  "49962": {
    "port_name": "Malacca (Pelabuhan Sungai Udang)",
    "country": "Malaysia"
  },
  "50055": {
    "port_name": "Batam (Sekupang)",
    "country": "Indonesia"
  },
  "50070": {
    "port_name": "Batam (Lalang Marine Terminal)",
    "country": "Indonesia"
  },
  "50210": {
    "port_name": "Pangkalpinang",
    "country": "Indonesia"
  },
  "50380": {
    "port_name": "Panjang",
    "country": "Indonesia"
  },
  "50730": {
    "port_name": "Medan (Belawan)",
    "country": "Indonesia"
  },
  "50925": {
    "port_name": "Jakarta (Banten)",
    "country": "Indonesia"
  },
  "50970": {
    "port_name": "Jakarta",
    "country": "Indonesia"
  },
  "51020": {
    "port_name": "Semarang (Tegal)",
    "country": "Indonesia"
  },
  "51130": {
    "port_name": "Surabaya",
    "country": "Indonesia"
  },
  "51280": {
    "port_name": "Mataram (Ampenan)",
    "country": "Indonesia"
  },
  "51350": {
    "port_name": "Waingapu",
    "country": "Indonesia"
  },
  "51440": {
    "port_name": "Dili",
    "country": "Timor-Leste"
  },
  "51501": {
    "port_name": "Belanak Field Terminal",
    "country": "Indonesia"
  },
  "51584": {
    "port_name": "Kuala Terengganu (Tg. Mani)",
    "country": "Malaysia"
  },
  "51811": {
    "port_name": "Bontang Lng Terminal",
    "country": "Indonesia"
  },
  "51860": {
    "port_name": "Kota Baru",
    "country": "Indonesia"
  },
  "52065": {
    "port_name": "Bitung",
    "country": "Indonesia"
  },
  "52240": {
    "port_name": "Kendari",
    "country": "Indonesia"
  },
  "52320": {
    "port_name": "Makassar (Ujung Pandang)",
    "country": "Indonesia"
  },
  "52510": {
    "port_name": "Ternate",
    "country": "Indonesia"
  },
  "53282": {
    "port_name": "Vanimo",
    "country": "Papua New Guinea"
  },
  "53490": {
    "port_name": "Brisbane",
    "country": "Australia"
  },
  "53655": {
    "port_name": "Sydney (Botany Bay)",
    "country": "Australia"
  },
  "54030": {
    "port_name": "Melbourne",
    "country": "Australia"
  },
  "54520": {
    "port_name": "Fremantle",
    "country": "Australia"
  },
  "54670": {
    "port_name": "Darwin",
    "country": "Australia"
  },
  "55080": {
    "port_name": "Tauranga",
    "country": "New Zealand"
  },
  "55130": {
    "port_name": "Napier",
    "country": "New Zealand"
  },
  "55230": {
    "port_name": "Auckland (Manukau Harbor)",
    "country": "New Zealand"
  },
  "55275": {
    "port_name": "Nelson (Tarakohe)",
    "country": "New Zealand"
  },
  "55330": {
    "port_name": "Akaroa",
    "country": "New Zealand"
  },
  "55350": {
    "port_name": "Timaru",
    "country": "New Zealand"
  },
  "55370": {
    "port_name": "Dunedin (Otago Harbor)",
    "country": "New Zealand"
  },
  "55530": {
    "port_name": "Lautoka Harbor",
    "country": "Fiji"
  },
  "55560": {
    "port_name": "Savusavu Bay",
    "country": "Fiji"
  },
  "55617": {
    "port_name": "Funafuti Atoll",
    "country": "Tuvalu"
  },
  "55840": {
    "port_name": "Papeete",
    "country": "French Polynesia"
  },
  "56270": {
    "port_name": "Honolulu (Barbers Point Terminal)",
    "country": "United States"
  },
  "56550": {
    "port_name": "Apra Harbor",
    "country": "Guam"
  },
  "57100": {
    "port_name": "Tulaghi",
    "country": "Solomon Islands"
  },
  "57200": {
    "port_name": "Luganville",
    "country": "Vanuatu"
  },
  "57230": {
    "port_name": "Port Vila",
    "country": "Vanuatu"
  },
  "57410": {
    "port_name": "Kuantan New Port",
    "country": "Malaysia"
  },
  "57435": {
    "port_name": "Pattani",
    "country": "Thailand"
  },
  "57462": {
    "port_name": "Laem Chabang",
    "country": "Thailand"
  },
  "57650": {
    "port_name": "Da Nang",
    "country": "Vietnam"
  },
  "57818": {
    "port_name": "Shenzhen (Chiwan)",
    "country": "China"
  },
  "57820": {
    "port_name": "Nanning (Qinzhou)",
    "country": "China"
  },
  "57840": {
    "port_name": "Hong Kong",
    "country": "Hong Kong"
  },
  "57870": {
    "port_name": "Xiamen",
    "country": "China"
  },
  "57890": {
    "port_name": "Taipei (Chi-Lung)",
    "country": "Taiwan"
  },
  "58320": {
    "port_name": "Manila (Batangas City)",
    "country": "Philippines"
  },
  "58370": {
    "port_name": "Manila",
    "country": "Philippines"
  },
  "58890": {
    "port_name": "Cebu (Tubigan)",
    "country": "Philippines"
  },
  "59190": {
    "port_name": "Iloilo",
    "country": "Philippines"
  },
  "59400": {
    "port_name": "Mati",
    "country": "Philippines"
  },
  "59485": {
    "port_name": "General Santos",
    "country": "Philippines"
  },
  "59580": {
    "port_name": "Zamboanga",
    "country": "Philippines"
  },
  "59720": {
    "port_name": "Cagayan de Oro (Bugo)",
    "country": "Philippines"
  },
  "59960": {
    "port_name": "Ningbo (Zhoushan)",
    "country": "China"
  },
  "59970": {
    "port_name": "Shanghai",
    "country": "China"
  },
  "59991": {
    "port_name": "Shanghai (Nantong)",
    "country": "China"
  },
  "60140": {
    "port_name": "Qingdao Gang",
    "country": "China"
  },
  "60165": {
    "port_name": "Yantai (Penglai)",
    "country": "China"
  },
  "60240": {
    "port_name": "Busan (Lushun)",
    "country": "China"
  },
  "60250": {
    "port_name": "Dalian",
    "country": "China"
  },
  "60390": {
    "port_name": "Busan",
    "country": "South Korea"
  },
  "61355": {
    "port_name": "Fukushima (Onahama Ko)",
    "country": "Japan"
  },
  "61370": {
    "port_name": "Chiba (Tateyama Ko)",
    "country": "Japan"
  },
  "61378": {
    "port_name": "Osaka (Katsunan Ko)",
    "country": "Japan"
  },
  "61695": {
    "port_name": "Hikari",
    "country": "Japan"
  },
  "61932": {
    "port_name": "Mega",
    "country": "Japan"
  },
  "62190": {
    "port_name": "Miyazaki (Hososhima Ko)",
    "country": "Japan"
  },
  "62380": {
    "port_name": "Sasebo",
    "country": "Japan"
  }
}
